<template>
    <div>
      <button @click="toggle">Toggle Items</button>
      <transition
        name="zoom"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
      >
        <div v-if="show" class="zoom-box">
          <p>Zoom In and Out Animation!</p>
        </div>
      </transition>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        show: true
      };
    },
    methods: {
      toggle() {
        this.show = !this.show;
      },
      beforeEnter(el) {
        el.style.transform = 'scale(0.5)';
        el.style.opacity = 0;
      },
      enter(el, done) {
        el.offsetHeight; // Trigger reflow
        el.style.transition = 'transform 0.5s ease, opacity 0.5s ease';
        el.style.transform = 'scale(1)';
        el.style.opacity = 1;
        done();
      },
      leave(el, done) {
        el.style.transition = 'transform 0.5s ease, opacity 0.5s ease';
        el.style.transform = 'scale(0.5)';
        el.style.opacity = 0;
        done();
      }
    }
  };
  </script>
  
  <style>
  .zoom-enter-active, .zoom-leave-active {
    transition: transform 0.5s ease, opacity 0.5s ease;
  }
  
  .zoom-enter, .zoom-leave-to /* .zoom-leave-active en <2.1.8 */ {
    transform: scale(1);
    opacity: 1;
  }
  
  .zoom-leave {
    transform: scale(0.5);
    opacity: 0;
  }
  </style>
  